export default __webpack_public_path__ + "static/4_19-5398a3a05032f968549233f82e702a4d.png";